import { createContext } from "react";
export const CharismaContext = createContext(undefined);
//# sourceMappingURL=Context.js.map